import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { usePromise } from '@rad/hooks';
import { Accordion } from '@rad/components/ui/accordion';
import CheckSwitch from '@rad/components/inputs/checkswitch';
const PermissionForm = ({ permissionsPromise, selectedPermissions, onChange }) => {
    const permissions = usePromise(permissionsPromise);
    const groups = React.useMemo(() => {
        if (!permissions)
            return [];
        const map = new Map();
        for (const p of permissions) {
            if (!map.has(p.entity))
                map.set(p.entity, []);
            map.get(p.entity).push(p);
        }
        return Array.from(map.entries()).map(([entity, perms]) => ({ entity, perms }));
    }, [permissions]);
    const togglePermission = (name) => {
        onChange(selectedPermissions.includes(name) ? selectedPermissions.filter(x => x !== name) : [...selectedPermissions, name]);
    };
    const toggleGroup = (perms) => {
        const names = perms.map(p => p.name);
        const allSelected = names.every(n => selectedPermissions.includes(n));
        onChange(allSelected ? selectedPermissions.filter(x => !names.includes(x)) : [...selectedPermissions, ...names.filter(n => !selectedPermissions.includes(n))]);
    };
    const toggleAll = () => {
        if (!permissions)
            return;
        const allSelected = permissions.every(p => selectedPermissions.includes(p.name));
        onChange(allSelected ? [] : permissions.map(p => p.name));
    };
    const accordionItems = groups.map(g => {
        const selectedCount = g.perms.filter(p => selectedPermissions.includes(p.name)).length;
        return {
            id: g.entity,
            title: _jsxs(_Fragment, { children: [_jsx("span", { className: "text-capitalize", children: g.entity.replace(/-/g, ' ') }), selectedCount > 0 && _jsxs("span", { className: "badge bg-primary ms-2", children: [selectedCount, "/", g.perms.length] })] }),
            content: (_jsxs("div", { className: "d-flex flex-column gap-2", children: [_jsx("button", { type: "button", className: "btn btn-link btn-sm p-0 text-decoration-none align-self-start", onClick: () => toggleGroup(g.perms), children: g.perms.every(p => selectedPermissions.includes(p.name)) ? 'Unselect all' : 'Select all' }), g.perms.map(p => (_jsx(CheckSwitch, { switch: false, label: p.action, value: selectedPermissions.includes(p.name), onChange: () => togglePermission(p.name) }, p.name)))] }))
        };
    });
    if (!permissions)
        return (_jsx("div", { className: "text-center py-3", children: _jsx("div", { className: "spinner-border spinner-border-sm" }) }));
    return _jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: "btn btn-sm btn-outline-secondary align-self-start", onClick: toggleAll, children: permissions.every(p => selectedPermissions.includes(p.name)) ? 'Unselect All Permissions' : 'Select All Permissions' }), _jsx(Accordion, { items: accordionItems, allowMultiple: true })] });
};
export default PermissionForm;
